"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_GROUP_SENDERS = void 0;
exports.ESTATUS_GROUP_SENDERS = {
    DE_BAJA: 0,
    DISPONIBLE: 1,
    ASIGNADO: 2,
};
